import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=581fc588&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=581fc588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581fc588",
  null
  
)

export default component.exports